import request from '@/utils/request'
import URL from '@/api/urlTranslator'

export function getJobByUuid(uuid) {
  return request({
    url: URL.booking.getJobByUuid,
    method: 'get',
    params: { uuid }
  })
}

// 加载Job的关联实体信息
export function loadJobRelated(data) {
  return request({
    url: URL.booking.loadJobRelated,
    method: 'post',
    data: data
  })
}

/**
 * 验证
 */
export function checking(checkNode, jobKey, lob) {
  return request({
    url: URL.booking.checking,
    method: 'get',
    params: { checkNode, jobKey, lob }
  })
}

/**
 * 验证
 */
export function checkingBySpecialNode(data) {
  return request({
    url: URL.booking.checkingBySpecialNode,
    method: 'post',
    data
  })
}

/**
 * 特殊节点验证
 */
export function checkChargeByBillPaymentSaveNode(data) {
  return request({
    url: URL.sys.checkChargeByBillPaymentSaveNode,
    method: 'post',
    data
  })
}
/**
 * 特殊节点验证
 */
export function checkChargeByInvoiceSaveNode(data) {
  return request({
    url: URL.sys.checkChargeByInvoice,
    method: 'post',
    data
  })
}

/**
 * 特殊节点验证
 */
export function checkChargeByBillingSaveNode(data) {
  return request({
    url: URL.sys.checkChargeByBillingSaveNode,
    method: 'post',
    data
  })
}

/**
 * 验证Job根据节点
 */
export function checkingWithNewData(checkNode, jobKey, lob, newJob) {
  const data = new FormData()
  if (newJob && Object.keys(newJob).length > 0) {
    data.append('newJobJson', JSON.stringify(newJob))
    data.append('newJobProperties', Object.keys(newJob).join(','))
  }
  return request({
    url: URL.sys.checkJobByNodeWithNewData,
    method: 'post',
    params: { checkNode, jobKey, lob },
    data
  })
}

/**
 * 验证
 */
export function checkingByAllLob(checkNode, jobKey) {
  return request({
    url: URL.booking.checkingByAll,
    method: 'get',
    params: { checkNode, jobKey }
  })
}

/**
 * 主管提交审核
 */
export function auditSubmission(jobKey, userId, orderAuditStatus, remark) {
  return request({
    url: URL.booking.auditSubmission,
    method: 'get',
    params: { jobKey, userId, orderAuditStatus, remark }
  })
}

/**
 * 提交审核给上级主管 并发送消息
 */
export function saveOrderAuditRemark(jobKey, remark, checkNode, userId, submitterUser, name) {
  return request({
    url: URL.booking.saveOrderAuditRemark,
    method: 'get',
    params: { jobKey, remark, checkNode, userId, submitterUser, name }
  })
}

/**
 * 提交审核给上级主管 并发送消息
 */
export function auditSubmissionSendMessage(jobKey, jobNo, userId, orderAuditStatus) {
  return request({
    url: URL.booking.auditSubmissionSendMessage,
    method: 'get',
    params: { jobKey, jobNo, userId, orderAuditStatus }
  })
}

// 根据主票，获取小票下面HBL的英文品名
export function getSlavesHBLEnglishName(params) {
  return request({
    url: URL.booking.getSlavesHBLEnglishName,
    method: 'get',
    params
  })
}

// 根据主票，获取小票下面HBL的唛头
export function getSlavesHBLMark(params) {
  return request({
    url: URL.booking.getSlavesHBLMark,
    method: 'get',
    params
  })
}

/**
 * 修改SOP状态，调用openAPI项目接口
 */
export function changeSopState(serverUrl, sessionId, jobKey, documentTypeKey) {
  return request({
    url: URL.booking.changeSopState,
    method: 'get',
    params: { serverUrl, sessionId, jobKey, documentTypeKey }
  })
}

// MBL并单
export function getJointSlavesMBL(params) {
  return request({
    url: URL.booking.getJointSlavesMBL,
    method: 'get',
    params
  })
}

// HBL并单
export function getJointSlavesHBL(params) {
  return request({
    url: URL.booking.getJointSlavesHBL,
    method: 'get',
    params
  })
}

// HWAB2并单
export function getJointSlavesHAWB2(params) {
  return request({
    url: URL.booking.getJointSlavesHAWB2,
    method: 'get',
    params
  })
}

// 查询多个job装箱信息
export function getListJobContainerUsages(params) {
  return request({
    url: URL.booking.getListJobContainerUsages,
    method: 'get',
    params
  })
}

// 费用调整保存
export function saveAdjustJob(data, params) {
  return request({
    url: URL.booking.saveAdjustJob,
    method: 'post',
    data,
    params
  })
}

// 费用删除
export function batchDeleteCharge(data) {
  return request({
    url: URL.booking.batchDeleteCharge,
    method: 'post',
    data
  })
}
// 销售页面保存费用方案生成的费用
export function saveChargeSchemeByJob(data) {
  return request({
    url: URL.booking.saveChargeSchemeByJob,
    method: 'post',
    data
  })
}

// 费用调整保存
export function updateLclSlaves(data) {
  return request({
    url: URL.booking.updateLclSlaves,
    method: 'put',
    data
  })
}

// 更新实际件毛体
export function updateQWCActual(data) {
  return request({
    url: URL.booking.updateQWCActual,
    method: 'put',
    data
  })
}

// 推动委托单到CBMS
export function sendJobCBMS(data) {
  return request({
    url: URL.booking.sendJobCBMS,
    method: 'post',
    data
  })
}

// 推动委托单到思锐
export function sendJobSiRui(params) {
  return request({
    url: URL.booking.sendJobSiRui,
    method: 'get',
    params
  })
}

export function syncLclSlaveMasterJob(data) {
  return request({
    url: URL.booking.syncLclSlaveMasterJob,
    method: 'post',
    data
  })
}

// 批量校验信控状态
export function batchCheckJobsCredit(data) {
  return request({
    url: URL.booking.batchCheckJobsCredit,
    method: 'post',
    data
  })
}

// 向主票中批量加入业务
export function batchAddJob(data, lclMasterUuid, mbl, location) {
  return request({
    url: URL.booking.batchAddJob,
    method: 'post',
    data,
    params: { lclMasterUuid, mbl, location }
  })
}

// 从主票中批量移除业务
export function batchRemoveJob(data, location) {
  return request({
    url: URL.booking.batchRemoveJob,
    method: 'delete',
    data,
    params: { location }
  })
}

export function validateDelJob(body) {
  const data = new FormData()
  for (const key in body) {
    data.append(key, body[key])
  }
  return request({
    url: URL.booking.validateDelJob,
    method: 'post',
    data
  })
}

export function batchDeleteJob(body) {
  const data = new FormData()
  for (const key in body) {
    data.append(key, body[key])
  }
  return request({
    url: URL.booking.batchDeleteJob,
    method: 'delete',
    data
  })
}

export function validateRevokeJob(body) {
  const data = new FormData()
  for (const key in body) {
    data.append(key, body[key])
  }
  return request({
    url: URL.booking.validateRevokeJob,
    method: 'post',
    data
  })
}

export function batchRevokeJob(body) {
  const data = new FormData()
  for (const key in body) {
    data.append(key, body[key])
  }
  return request({
    url: URL.booking.batchRevokeJob,
    method: 'delete',
    data
  })
}

// 销售查询
export function findJobForSales(data) {
  return request({
    url: URL.booking.findJobForSales,
    method: 'post',
    data
  })
}

export function findLclSlavesForMasterUuid(data) {
  return request({
    url: URL.booking.findLclSlavesForMasterUuid,
    method: 'get',
    params: data
  })
}

// 销售查询【销售部、海外部】
export function findMoreJobForSales2HW(data) {
  return request({
    url: URL.booking.findMoreJobForSales2HW,
    method: 'post',
    data
  })
}

// 更新销售要求【销售部、海外部】
export function updateSalesAndUserDefined(data) {
  return request({
    url: URL.booking.updateSalesAndUserDefined,
    method: 'post',
    data
  })
}

// 根据角色权限获取对应的部门Id
export function getDepartmentIdOfRole(data) {
  return request({
    url: URL.booking.getDepartmentIdOfRole,
    method: 'get',
    params: data
  })
}

// 远程订舱查询
export function remoteBookingQuery(data) {
  return request({
    url: URL.booking.remoteBookingQuery,
    method: 'post',
    data
  })
}

export function approvedJob(data) {
  return request({
    url: URL.booking.approvedJob,
    method: 'put',
    data
  })
}

// 查询提单号
export function queryJobMBL(params) {
  return request({
    url: URL.booking.queryJobMBL,
    method: 'get',
    params
  })
}
// 获取业务的文件历史、文件查询列表
export function queryFileHistory(data) {
  return request({
    url: URL.booking.queryFileHistory,
    method: 'post',
    data
  })
}

// 查询jobs
export function queryJobs(data) {
  return request({
    url: URL.booking.queryJobs,
    method: 'post',
    data
  })
}

// 更新Job列表
export function updateJobs(data, params) {
  return request({
    url: URL.booking.updateJobs,
    method: 'put',
    data,
    params
  })
}

// 根据mbl或jobNo查询业务
export function queryByNoOrMblFileFunc(data) {
  return request({
    url: URL.booking.queryNoByNoOrMblForFile,
    method: 'post',
    data
  })
}
// 根据mbl或jobNo查询业务
export function queryByNoOrMblCustomFunc(data) {
  return request({
    url: URL.booking.queryNoByNoOrMblForCustom,
    method: 'post',
    data
  })
}

export function queryJobByFilePageableFunc(data) {
  return request({
    url: URL.booking.queryJobByFilePageableUrl,
    method: 'post',
    data
  })
}
// 查询订舱回执接收列表
export function queryEdiReceipts(params) {
  return request({
    url: URL.booking.ediReceipt.queryEdiReceipts,
    method: 'get',
    params
  })
}
// 查询订舱回执接收列表
export function syncBc(data) {
  return request({
    url: URL.booking.ediReceipt.syncBc,
    method: 'post',
    data
  })
}
// 查询通讯回执接收列表
export function queryAcEdiReceipt(params) {
  return request({
    url: URL.booking.ediReceipt.queryAcEdiReceipt,
    method: 'get',
    params
  })
}
// 查询订舱回执箱货列表
export function queryEdiReceiptContainers(data) {
  return request({
    url: URL.booking.ediReceipt.queryEdiReceiptContainers,
    method: 'post',
    data
  })
}
// 查询订舱回执日期信息列表
export function queryEdiReceiptTimes(data) {
  return request({
    url: URL.booking.ediReceipt.queryEdiReceiptTimes,
    method: 'post',
    data
  })
}
// 查询订舱回执港口信息列表
export function queryEdiReceiptPorts(data) {
  return request({
    url: URL.booking.ediReceipt.queryEdiReceiptPorts,
    method: 'post',
    data
  })
}

// 修改费用锁定状态
export function modifyChargeLockStatus(params) {
  return request({
    url: URL.booking.modifyChargeLockStatus,
    method: 'get',
    params: params
  })
}

// 验证费用的锁定状态
export function validateChargeLockStatus(data) {
  return request({
    url: URL.booking.validateChargeLockStatus,
    method: 'post',
    data: data
  })
}
// 根据收付类型校验费用锁定状态
export function validateChargeLockStatusByType(data, params) {
  return request({
    url: URL.booking.validateChargeLockStatusByType,
    method: 'post',
    data,
    params
  })
}
// 批量撤回提交/预提交
export function batchReturnSubmit(data) {
  return request({
    url: URL.booking.batchReturnSubmit,
    method: 'post',
    data: data
  })
}
// 批量撤回锁定应收/应付
export function batchModifyChargeLockStatus(data) {
  return request({
    url: URL.booking.batchModifyChargeLockStatus,
    method: 'post',
    data: data
  })
}
// 批量修改约号
export function batchUpdateScNo(data) {
  return request({
    url: URL.booking.batchUpdateScNo,
    method: 'post',
    data: data
  })
}
// 批量修改自定义业务类型
export function updateJobCustomJobType(data) {
  return request({
    url: URL.booking.updateJobCustomJobType,
    method: 'post',
    data: data
  })
}

// 根据权限选择委托单位的控件数据
export function getCustomerByRole(params) {
  return request({
    url: URL.booking.getCustomerByRole,
    method: 'get',
    params
  })
}

// 销售、客服 所绑定的合作伙伴
export function getCustomerBySalesCsr(params) {
  return request({
    url: URL.booking.getCustomerBySalesCsr,
    method: 'get',
    params
  })
}

// 根据权限选择委托单位的控件数据(FBA使用)
export function getFbaCustomerByRole(params) {
  return request({
    url: URL.booking.getFbaCustomerByRole,
    method: 'get',
    params
  })
}

// 询价管理根据权限选择委托单位的控件数据
export function getInquiryCustomerByRole(params) {
  return request({
    url: URL.booking.getInquiryCustomerByRole,
    method: 'get',
    params
  })
}

// 撤回 提交、预提交
export function backReturn(data) {
  return request({
    url: URL.booking.backReturn,
    method: 'post',
    data: data
  })
}

// 正常提交业务
export function normalCommitJob(data) {
  return request({
    url: URL.booking.normalCommitJob,
    method: 'post',
    data
  })
}

// 根据业务编号查询
export function queryJobNoLinkFunc(params) {
  return request({
    url: URL.booking.queryJobNoLinkUrl,
    method: 'get',
    params
  })
}

// 批量主管提交
export function batchManagerCommit(requestBody) {
  return request({
    url: URL.booking.batchManagerCommit,
    method: 'post',
    data: requestBody
  })
}

// 当MBL和HBL都存在时，校验是否重复
export function isExistHBLANDMBL(params) {
  return request({
    url: URL.booking.isExistHBLANDMBL,
    method: 'get',
    params
  })
}
// 销售信息调整
export function updateJobFields(data) {
  return request({
    url: URL.booking.updateJobFields,
    method: 'post',
    data: data
  })
}

// 批量修改业务编号
export function batchModifyJobNo(data) {
  return request({
    url: URL.booking.batchModifyJobNo,
    method: 'post',
    data: data
  })
}
// 验证操作分公司是否配置了验证规则
export function hasCheckRuleCondition(data) {
  return request({
    url: URL.booking.hasCheckRuleCondition,
    method: 'post',
    data: data
  })
}
// 跨租户海出转海进-修改费用同步确认状态
export function syncCrossTenantCharge(chargeKeys, jobKey, location) {
  return request({
    url: URL.booking.syncCrossTenantCharge,
    method: 'post',
    data: chargeKeys,
    params: { jobKey, location }
  })
}
// 应付费用同步
export function syncPayableCharge(chargeKeys, jobKey, location) {
  return request({
    url: URL.booking.syncPayableCharge,
    method: 'post',
    data: chargeKeys,
    params: { jobKey, location }
  })
}

// 跨租户海出转海进-取消费用同步
export function cancelSyncCrossTenantCharge(chargeKeys, jobKey, location) {
  return request({
    url: URL.booking.cancelSyncCrossTenantCharge,
    method: 'post',
    data: chargeKeys,
    params: { jobKey, location }
  })
}
// 跨租户海出转海进-修改费用同步确认状态
export function updateChargeSyncConfirmStatus(chargeKeys, syncConfirmStatus, jobUuid) {
  return request({
    url: URL.booking.updateChargeSyncConfirmStatus,
    method: 'post',
    data: chargeKeys,
    params: { syncConfirmStatus, jobUuid }
  })
}
// 跨租户海出转海进-获取变更历史记录
export function queryCrossTenantSyncHistory(params) {
  return request({
    url: URL.booking.queryCrossTenantSyncHistory,
    method: 'get',
    params
  })
}

// 查看api请求结果日志
export function queryApiReqLog(jobUuid) {
  return request({
    url: URL.booking.queryApiReqLog,
    method: 'get',
    params: { jobUuid }
  })
}

// 查看api请求结果日志
export function queryApiRespLog(jobUuid) {
  return request({
    url: URL.booking.queryApiRespLog,
    method: 'get',
    params: { jobUuid }
  })
}

// 跨租户海出转海进-更新变更历史记录已读状态
export function updateCrossTenantSyncHistory(params) {
  return request({
    url: URL.booking.updateCrossTenantSyncHistory,
    method: 'get',
    params
  })
}

export function checkChargeByAdjust(uuid) {
  return request({
    url: URL.booking.checkChargeByAdjust,
    method: 'get',
    params: { uuid }
  })
}

export function batchCheckChargeByAdjust(data) {
  return request({
    url: URL.booking.batchCheckChargeByAdjust,
    method: 'post',
    data
  })
}

// 加载Job关联业务的的关联实体信息，当前支持sop
export function loadCrossTenantRelatedJob(params) {
  return request({
    url: URL.booking.loadCrossTenantRelatedJob,
    method: 'get',
    params
  })
}

export function checkBySaveJobNode(data) {
  return request({
    url: URL.sys.checkBySaveJobNode,
    method: 'post',
    data
  })
}

// 根据主票的UUID查询箱号
export function queryContainerNoByLclMasterUuid(jobUuid) {
  return request({
    url: URL.booking.queryContainerNoByLclMasterUuid,
    method: 'get',
    params: { jobUuid }
  })
}

// 同步费用确认（出口同步到进口）
export function syncChargeToImportConfirm(body) {
  const data = new FormData()
  for (const key in body) {
    data.append(key, body[key])
  }
  return request({
    url: URL.booking.syncChargeToImportConfirm,
    method: 'post',
    data
  })
}

// 同步费用（进口同步到出口）
export function syncImportChargeToExport(body, location) {
  const data = new FormData()
  for (const key in body) {
    data.append(key, body[key])
  }
  return request({
    url: URL.booking.syncChargeToExport,
    method: 'post',
    data,
    params: { location }
  })
}

// 同步费用确认（进口同步到出口）
export function syncChargeToExportConfirm(body) {
  const data = new FormData()
  for (const key in body) {
    data.append(key, body[key])
  }
  return request({
    url: URL.booking.syncChargeToExportConfirm,
    method: 'post',
    data
  })
}

// 同步费用确认（交叉委托）
export function syncChargeConfirm(body) {
  const data = new FormData()
  for (const key in body) {
    data.append(key, body[key])
  }
  return request({
    url: URL.booking.syncChargeConfirm,
    method: 'post',
    data
  })
}

// 批量同步费用确认（交叉委托）
export function syncChargeConfirmBatch(data) {
  return request({
    url: URL.booking.syncChargeConfirmBatch,
    method: 'post',
    data
  })
}

// 查询待处理的费用同步记录条数
export function pendingChargeSyncRecordCount(params) {
  return request({
    url: URL.booking.pendingChargeSyncRecordCount,
    method: 'get',
    params
  })
}

// 查询待处理的外部费用同步记录条数
export function pendingChargeOutSyncRecordCount(params) {
  return request({
    url: URL.booking.pendingChargeOutSyncRecordCount,
    method: 'get',
    params
  })
}

// 查询费用同步记录
export function queryChargeSyncRecord(params) {
  return request({
    url: URL.booking.queryChargeSyncRecord,
    method: 'get',
    params
  })
}

// 费用同步审核通过
export function passChargeSync(data, params) {
  return request({
    url: URL.booking.passChargeSync,
    method: 'post',
    data,
    params
  })
}

// 费用同步审核通过
export function passChargeSyncRecall(data, params) {
  return request({
    url: URL.booking.passChargeSyncRecall,
    method: 'post',
    data,
    params
  })
}

// 更新费用同步记录为已读
export function updateChargeSyncRecordRead(data) {
  return request({
    url: URL.booking.updateChargeSyncRecordRead,
    method: 'post',
    data
  })
}

// 更新费用同步记录为已读
export function updateChargeSyncRecallState(data) {
  return request({
    url: URL.booking.updateChargeSyncRecallState,
    method: 'post',
    data: data
  })
}

// 费用同步审核不通过
export function notPassChargeSync(data, params) {
  return request({
    url: URL.booking.notPassChargeSync,
    method: 'post',
    data,
    params
  })
}

// 费用同步审核不通过
export function notPassChargeSyncRecall(data, params) {
  return request({
    url: URL.booking.notPassChargeSyncRecall,
    method: 'post',
    data,
    params
  })
}

// 获取当前海出业务sop模板uuid接口
export function getSEJobSopInfo(data) {
  return request({
    url: URL.seaExport.getSEJobSopInfo,
    method: 'post',
    data
  })
}

// 获取当前海进业务sop模板uuid接口
export function getSIJobSopInfo(data) {
  return request({
    url: URL.seaExport.getSIJobSopInfo,
    method: 'post',
    data
  })
}

// 获取当前空出业务sop模板uuid接口
export function getAEJobSopInfo(data) {
  return request({
    url: URL.seaExport.getAEJobSopInfo,
    method: 'post',
    data
  })
}

// 获取当前空进业务sop模板uuid接口
export function getAIJobSopInfo(data) {
  return request({
    url: URL.seaExport.getAIJobSopInfo,
    method: 'post',
    data
  })
}

// 获取当前铁出业务sop模板uuid接口
export function getREJobSopInfo(data) {
  return request({
    url: URL.seaExport.getREJobSopInfo,
    method: 'post',
    data
  })
}

export function getIEJobSopInfo(data) {
  return request({
    url: URL.seaExport.getIEJobSopInfo,
    method: 'post',
    data
  })
}

// 销售-远程订舱-提交预审状态
export function submitPreVerifyState(body) {
  const data = new FormData()
  for (const key in body) {
    data.append(key, body[key])
  }
  return request({
    url: URL.booking.submitPreVerifyState,
    method: 'post',
    data
  })
}

// 销售-远程订舱-提交跳过预审到正操作
export function submitSkipPreVerify(body) {
  const data = new FormData()
  for (const key in body) {
    data.append(key, body[key])
  }
  return request({
    url: URL.booking.submitSkipPreVerify,
    method: 'post',
    data
  })
}

// 批量退回业务预审/远程订舱
export function batchReturnPreApproval(params) {
  return request({
    url: URL.booking.batchReturnPreApproval,
    method: 'post',
    data: params
  })
}

// 批量修改岗位和岗位部门
export function batchUpdateBusinessPeopleType(params) {
  return request({
    url: URL.booking.batchUpdateBusinessPeopleType,
    method: 'post',
    data: params
  })
}

// 批量修改货物大类
export function batchUpdateCategoryOfGoodsType(params) {
  return request({
    url: URL.booking.batchUpdateCategoryOfGoodsType,
    method: 'post',
    data: params
  })
}

// 批量修改运输公司、订舱代理、仓库供应商等数据类型
export function batchUpdateDataType(params) {
  return request({
    url: URL.booking.batchUpdateDataType,
    method: 'post',
    data: params
  })
}

// 批量修改目的港信息
export function batchModifyPodInfo(data) {
  return request({
    url: URL.booking.batchModifyPodInfo,
    method: 'post',
    data
  })
}

// 批量更新预审状态
export function batchUpdatePreVerifyState(keys, preverifyState) {
  return request({
    url: URL.booking.batchUpdatePreVerifyState,
    method: 'post',
    data: keys,
    params: { preverifyState }
  })
}

// 批量更新预审和job状态
export function batchUpdatePreVerifyStateAndJobState(keys, preverifyState, jobState, branchId) {
  return request({
    url: URL.booking.batchUpdatePreVerifyStateAndJobState,
    method: 'post',
    data: keys,
    params: { preverifyState, jobState, branchId }
  })
}

// 查询是否相同进仓编号的业务
export function selectWarehouseNoExist(params) {
  return request({
    url: URL.booking.selectWarehouseNoExist,
    method: 'get',
    params
  })
}

// 取消审核校验
export function checkCancelAudit(data) {
  return request({
    url: URL.booking.checkCancelAudit,
    method: 'post',
    data: data
  })
}

// 获取业务BPM相关信息
export function getJobBpm(params) {
  return request({
    url: URL.booking.getJobBpm,
    method: 'get',
    params
  })
}

// 修改业务部分字段
export function updateFields(data) {
  return request({
    url: URL.booking.updateFields,
    method: 'post',
    data
  })
}

// 批量修改计划离泊时间/预计到港时间
export function batchUpdateDateFunc(data) {
  return request({
    url: URL.booking.batchUpdateDateUrl,
    method: 'post',
    data
  })
}
// 批量修改当前计划离泊时间(Current ETD)/当前计划到港时间(Current ETA)
export function batchUpdateCurDateFunc(data) {
  return request({
    url: URL.booking.batchUpdateCurDateUrl,
    method: 'post',
    data
  })
}

// 批量修改原始计划离泊时间(Original ETD)/原始计划到港时间(Original ETA)
export function batchUpdateOriginalDateFunc(data) {
  return request({
    url: URL.booking.batchUpdateOriginalDateUrl,
    method: 'post',
    data
  })
}

// 批量修改批量修改实际离泊时间(ATD)/实际到港时间(ATA) 实际起飞时间(ATD)/实际抵达时间(ATA)
export function batchUpdateAtdAtaDateFunc(data) {
  return request({
    url: URL.booking.batchUpdateAtdAtaDateUrl,
    method: 'post',
    data
  })
}

// 查询业务锁定配置
export function queryAutoLockFunc(data) {
  return request({
    url: URL.booking.queryAutoLockUrl,
    method: 'post',
    data
  })
}

// 保存业务锁定配置
export function saveAutoLockFunc(data) {
  return request({
    url: URL.booking.saveAutoLockUrl,
    method: 'post',
    data
  })
}

// 批量锁定 解锁业务
export function batchLockJobFunc(data) {
  return request({
    url: URL.booking.batchLockJobUrl,
    method: 'post',
    data
  })
}

export function checkPoNoIsExist(poNo, jobUuid) {
  return request({
    url: URL.booking.checkPoNoIsExist,
    method: 'get',
    params: { poNo, jobUuid }
  })
}

export function checkBsItemOpened(code) {
  return request({
    url: URL.booking.checkBsItemOpened,
    method: 'get',
    params: { code }
  })
}
export function checkBsBalanceFunc(code, num) {
  return request({
    url: URL.booking.checkBsBalanceUrl,
    method: 'get',
    params: { code, num }
  })
}

// 文件历史-处理一键发送状态
export function doOneClickSend(data) {
  return request({
    url: URL.booking.doOneClickSend,
    method: 'post',
    data
  })
}

// 文件历史-处理一键发送状态 批量（不区分主小票）
export function doOneClickSendMulti(data) {
  return request({
    url: URL.booking.doOneClickSendMulti,
    method: 'post',
    data
  })
}

// 文件历史-重置一键发送状态
export function resetOneClickSend(uuid) {
  return request({
    url: URL.booking.resetOneClickSend,
    method: 'post',
    data: { keys: [uuid] }
  })
}

// 根据箱号查询业务
export function queryJobByContainerNo(params) {
  return request({
    url: URL.booking.queryJobByContainerNo,
    method: 'get',
    params
  })
}

// 根据人工匹配条件查询业务
export function queryJobByManualMatch(params) {
  return request({
    url: URL.booking.queryJobByManualMatch,
    method: 'get',
    params
  })
}

/**
 * 验证
 */
export function checkExplainByJobs(data) {
  return request({
    url: URL.sys.checkExplainByJobs,
    method: 'post',
    data
  })
}

/**
 * 批量查询job通过uuids
 */
export function getJobByKeys(data) {
  return request({
    url: URL.booking.getJobByKeys,
    method: 'post',
    data: data
  })
}

/**
 * 批量查询seaJob通过uuids
 * @param data
 * @returns {AxiosPromise}
 */
export function getSeaExportByKeys(data) {
  return request({
    url: URL.booking.getSeaExportByKeys,
    method: 'post',
    data: data
  })
}

// 业务提交时校验是否预付款余额不足
export function checkBalanceBeforeSubmit(data) {
  return request({
    url: URL.booking.checkBalanceBeforeSubmitUrl,
    method: 'post',
    data: data
  })
}

// 撤销关联的业务
export function revokeJobFunc(data) {
  return request({
    url: URL.booking.revokeJobUrl,
    method: 'post',
    data: data
  })
}

// 获取Job关联的辅助信息
export function loadJobAncillaryInformation(data) {
  return request({
    url: URL.booking.loadJobAncillaryInformation,
    method: 'post',
    data: data
  })
}

// 下载9610文件
export function export9610FileUrl(jobKey) {
  return request({
    url: URL.booking.export9610FileUrl,
    method: 'post',
    params: { jobKey }
  })
}

// 获取Job关联的辅助信息
export function batchModifyJobOffice(data) {
  return request({
    url: URL.booking.batchModifyJobOffice,
    method: 'post',
    data: data
  })
}

// 执行任务 调试执行
export function pushMlsDataDeBugFunc(requestBody) {
  return request({
    url: URL.booking.pushMlsDataDeBugFuncUrl,
    method: 'post',
    data: requestBody
  })
}

// 获取主票及小票中的换单代理
export function getExChangeAgentsByJobUuid(params) {
  return request({
    url: URL.booking.getExChangeAgentsByJobUuid,
    method: 'get',
    params
  })
}

// 获取小票和装箱信息
export function getSlaveJobsAndContainers(params) {
  return request({
    url: URL.booking.getSlaveJobsAndContainers,
    method: 'get',
    params
  })
}

// 锁定HBL
export function lockHbl(body) {
  const data = new FormData()
  for (const key in body) {
    data.append(key, body[key])
  }
  return request({
    url: URL.booking.lockHbl,
    method: 'post',
    data
  })
}

// 更新询价业务审核状态
export function updateInquiryJobState(jobUuid, type, state) {
  return request({
    url: URL.booking.updateInquiryJobState,
    method: 'get',
    params: { jobUuid, type, state }
  })
}

export function validateJobForDelete(body) {
  return request({
    url: URL.booking.validateJobForDelete,
    method: 'post',
    data: body
  })
}

// 批量修改业务基本数据字段-备注
export function batchUpdateJobDataFunc(data) {
  return request({
    url: URL.booking.batchUpdateJobDataUrl,
    method: 'post',
    data
  })
}

// 批量修改业务订舱代理检查逻辑
export function validateBatchBookingAgent(data) {
  return request({
    url: URL.booking.validateBatchBookingAgent,
    method: 'post',
    data
  })
}

// 批量修改业务订舱代理
export function batchUpdateBookingAgent(data) {
  return request({
    url: URL.booking.batchUpdateBookingAgentUrl,
    method: 'post',
    data
  })
}

/**
 * 查询验证结果日志
 */
export function queryCheckRuleResults(data) {
  return request({
    url: URL.booking.queryCheckRuleResultsUrl,
    method: 'post',
    data: data
  })
}
/**
 * 报价确认&取消确认
 */
export function businessQuotationFunc(data) {
  return request({
    url: URL.booking.businessQuotationUrl,
    method: 'post',
    data: data
  })
}
